/* Heading.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["children", "hideBorder"];
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const _4 = "._n3tdpxbi{padding-bottom:var(--ds-space-200,1pc)}";
const _3 = "._n7zlpp12{border-bottom:var(--_18x9sjc)}";
const _2 = "._n3tdidpf{padding-bottom:0}";
const _ = "._18s81b6a{margin:var(--_1jrp3en)}";
import { H4 } from '@atlassian/mpac-primitives';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const HeadingWrapper = null;
const BottomBorder = null;
export const Heading = props => {
  const {
      children,
      hideBorder = false
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4]
    }), /*#__PURE__*/_jsx("div", {
      className: ax(["_18s81b6a _n3tdidpf", !hideBorder && "_18s81b6a _n7zlpp12 _n3tdpxbi"]),
      style: {
        "--_1jrp3en": ix("0 0 ".concat("var(--ds-space-300, 24px)", " 0")),
        "--_18x9sjc": ix("1px solid ".concat("var(--ds-border, #091E4224)"))
      },
      children: /*#__PURE__*/_jsx(H4, _objectSpread(_objectSpread({
        as: "h2"
      }, otherProps), {}, {
        children: children
      }))
    })]
  });
};